import { NineNgotMiniApp } from "@/components/nine-ngot-mini-app";
import "./App.css";

function App() {
  return <NineNgotMiniApp />;
}

export default App;
